import { useEffect, useState } from "react";

/**
 * Auto-advancing crossfade image slider with dot navigation.
 */
export default function ImageSlider({ images, cycleSeconds = 5, className = "" }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (images.length < 2) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, cycleSeconds * 1000);
    return () => clearInterval(id);
  }, [images.length, cycleSeconds]);

  return (
    <div className={`img-slider ${className}`}>
      {images.map((img, i) => (
        <img
          key={img.src}
          src={img.src}
          alt={img.alt}
          className={`img-slider-slide${i === index ? " active" : ""}`}
        />
      ))}
      {images.length > 1 && (
        <div className="img-slider-dots">
          {images.map((img, i) => (
            <button
              key={img.src}
              type="button"
              className={`img-slider-dot${i === index ? " active" : ""}`}
              aria-label={`Show image ${i + 1}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
